import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setupIonicReact } from '@ionic/react';

// Los estilos de Ionic y Leaflet se importan dentro de global.css en una capa CSS propia.
import './styles/global.css';

import { App } from './App';
import { initTheme } from './stores/theme';
import { registerServiceWorker, reloadOnStaleChunk } from './lib/pwa';
import { unlockAudioOnFirstTouch } from './lib/sound';
import { startTranslator } from './i18n/translator';

setupIonicReact({ mode: 'ios', swipeBackEnabled: true });
initTheme();
registerServiceWorker();
unlockAudioOnFirstTouch();
// Vite avisa cuando no puede cargar un fragmento de una versión anterior.
window.addEventListener('vite:preloadError', (e) => {
  if (reloadOnStaleChunk()) e.preventDefault();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
// Inglés: traduce la interfaz al vuelo (el español es el idioma original).
startTranslator();
